import { render } from "./EditObjectRelation.vue?vue&type=template&id=11cb6a9c"
import script from "./EditObjectRelation.vue?vue&type=script&lang=js"
export * from "./EditObjectRelation.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__